import React from 'react';
import {Alert, Box, Typography} from '@mui/material';
import {Control, FieldValues} from 'react-hook-form';
import AppSelectList, {
    IDropDownOptions
} from '../../../../Component/Common/Components/FormValidationInputs/AppSelectList';
import {payrollImportTypeOptions} from '../../../../Component/Common/Constants/Lists/DropdownListOptions';
import colors from '../../../../assets/theme/base/colors';
import {ImportStep, stepFieldWidth} from './ImportStep';

interface IProps {
    control: Control<FieldValues>;
    organisations: IDropDownOptions[];
    selectedOrganisation: number;
    hasFetchedData: boolean;
    salaryFetchAvailable: boolean;
    canImportSalaries: boolean;
    disabled: boolean;
}

export const SourceStep: React.FC<IProps> =
    ({
         control,
         organisations,
         selectedOrganisation,
         hasFetchedData,
         salaryFetchAvailable,
         canImportSalaries,
         disabled
     }) => {

        return (
            <ImportStep stepNumber={1} title="Source" description="Where the data comes from.">
                <Box sx={{maxWidth: stepFieldWidth}}>
                    <AppSelectList
                        control={control}
                        name="organisationId"
                        label="Organisation"
                        items={organisations}/>
                </Box>

                {selectedOrganisation > 0 &&
                    <Box sx={{maxWidth: stepFieldWidth}}>
                        <AppSelectList
                            control={control}
                            name="includeSalaries"
                            label="What data would you like to import?"
                            items={payrollImportTypeOptions}
                            disabledItems={!salaryFetchAvailable || !canImportSalaries ? [1] : []}
                            disabled={disabled}/>
                    </Box>
                }

                {selectedOrganisation > 0 && salaryFetchAvailable && !canImportSalaries &&
                    <Typography variant="caption" sx={{color: colors.error.main}}>
                        You don't have permission to edit salaries for the selected scorecards
                    </Typography>
                }

                {selectedOrganisation > 0 && hasFetchedData && !salaryFetchAvailable &&
                    <Alert severity="warning">
                        No salary data was found in the most recent fetch. To import salary data, ensure the payroll
                        connection is set to 'Employee Structure and Salaries' and run a new Fetch Data.
                    </Alert>
                }
            </ImportStep>
        );
    };
